module.exports = __webpack_public_path__ + "static/Gotham-BlackItalic-3a3941f859de5808e083f10f76cda94c.ttf";